import { MANIFEST_URL, R2_PUBLIC_BASE, WORKER_BASE, R2_ENABLED } from "./config.js";

// ── Manifest ──────────────────────────────────────────────────
// activities-manifest.json 結構（由 worker 維護）：
// {
//   version: 1,
//   updatedAt: ISOString,
//   activities: {
//     "<activity_id>": { photos: [{ id, exifDate, thumb, medium, original, uploader, uploadedAt, originalName, size }] }
//   }
// }

export async function fetchManifest() {
  if (!R2_ENABLED || !MANIFEST_URL) {
    return { version: 1, updatedAt: null, activities: {} };
  }
  try {
    const res = await fetch(`${MANIFEST_URL}?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) {
      if (res.status === 404) return { version: 1, updatedAt: null, activities: {} };
      throw new Error(`Manifest HTTP ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    console.warn("fetchManifest failed:", err);
    return { version: 1, updatedAt: null, activities: {} };
  }
}

export function photoUrl(path) {
  return R2_PUBLIC_BASE ? `${R2_PUBLIC_BASE}/${path}` : path;
}

// ── Covers（封面選擇）──────────────────────────────────────────
const COVERS_URL = R2_PUBLIC_BASE ? `${R2_PUBLIC_BASE}/activities-covers.json` : "";

export async function fetchCovers() {
  if (!COVERS_URL) return {};
  try {
    const res = await fetch(`${COVERS_URL}?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
}

export async function setCoverSet(activityId, photoIds) {
  if (!WORKER_BASE) throw new Error("worker_not_configured");
  const res = await fetch(`${WORKER_BASE}/api/cover`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ activity_id: activityId, photo_ids: photoIds }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Cover HTTP ${res.status}`);
  return data;
}

// ── Session ticket（一次 Turnstile 換 10 分鐘 ticket）─────────
export async function getSessionTicket(turnstileToken) {
  if (!WORKER_BASE) throw new Error("worker_not_configured");
  const res = await fetch(`${WORKER_BASE}/api/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ turnstile_token: turnstileToken }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const codes = Array.isArray(data.codes) ? ` [${data.codes.join(",")}]` : "";
    throw new Error(`${data.error || `Session HTTP ${res.status}`}${codes}`);
  }
  return { ticket: data.ticket, exp: data.exp };
}

// ── Upload ────────────────────────────────────────────────────
export async function uploadPhoto({ activityId, uploader, exifDate, thumb, medium, original, sessionTicket }) {
  if (!WORKER_BASE) throw new Error("worker_not_configured");
  const fd = new FormData();
  fd.append("activity_id", activityId);
  fd.append("uploader", uploader || "");
  fd.append("exif_date", exifDate ? new Date(exifDate).toISOString() : "");
  fd.append("session_ticket", sessionTicket);
  fd.append("thumb", thumb);
  fd.append("medium", medium);
  fd.append("original", original);

  const res = await fetch(`${WORKER_BASE}/api/upload`, {
    method: "POST",
    body: fd,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    console.warn("[upload-fail]", data);
    const reason = data.reason ? ` (${data.reason})` : "";
    throw new Error(`${data.error || `HTTP ${res.status}`}${reason}`);
  }
  return data;
}
